import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface Column {
  field: string;
  headerName: string;
  width?: number | string;
}

interface HistroyTableProps {
  columns: Column[];
  data: any[];
  highlightRow?: (row: any) => boolean;
}

const HistroyTable: React.FC<HistroyTableProps> = ({
  columns,
  data,
  highlightRow,
}) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 20;

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const paginatedData = data.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper sx={{ borderRadius: 1, boxShadow: 1, overflow: "hidden" }}>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="reusable table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#009DFF !important" }}>
              {columns.map((col) => (
                <TableCell
                  key={col.field}
                  sx={{
                    color: "#ffffff",
                    fontWeight: "500",
                    fontSize: 16,
                    borderBottom: "2px solid #009DFF",
                    width: col.width || "auto",
                    backgroundColor: "#009DFF !important",
                  }}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedData.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  transition: "background-color 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    "& .MuiTypography-root": {
                      color: "#007bff",
                    },
                  },
                  
                }}
              >
                {columns.map((col) => (
                  <TableCell key={col.field}>
                    <Typography
                      variant="body2"
                      color="text.primary"
                      sx={{
                        transition: "color 0.2s ease",
                        fontSize: "15px",
                      }}
                    >
                      {row[col.field]}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}

            {paginatedData.length === 0 && (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", py: 2 }}
                  >
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Custom Pagination */}
      {data.length > rowsPerPage && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          p={2}
          gap={1}
          sx={{ borderTop: "1px solid #e0e0e0", backgroundColor: "#fafafa" }}
        >
          <IconButton
            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
            disabled={page === 0}
            size="small"
          >
            <ArrowBackIosIcon fontSize="small" />
          </IconButton>

          <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>
            Page {page + 1} of {totalPages}
          </Typography>

          <IconButton
            onClick={() =>
              setPage((prev) => Math.min(prev + 1, totalPages - 1))
            }
            disabled={page >= totalPages - 1}
            size="small"
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Paper>
  );
};

export default HistroyTable;
